import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import bg3 from "../assect/images/website/pic1.jpg";
import hero from "../assect/images/website/pic10.jpg";
import image1 from "../assect/images/website/pic9.jpg";
import dots from "../assect/images/svg/dots.svg";
import home from "../assect/images/icons/home-insurance.png";
import flood from "../assect/images/icons/flood-insurance.png";
import health from "../assect/images/icons/healthcare-insurance.png";
import life from "../assect/images/icons/life-insurance.png";
import car from "../assect/images/icons/car-insurance.png";
import business from "../assect/images/icons/business-insurance.png";
import annuities from "../assect/images/icons/annuities-insurance.png";
import { FiHexagon } from "../assect/icons/vander";
import RoutesEnums from "../enums/routes.enums";
import { data2 } from "../language/RealStateBrokage.js";

export default function Features() {
  let navigate = useNavigate();

  const featureData2 = [
    {
      icon: home,
      title: "Home Insurance",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: flood,
      title: "Flood Insurance",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: health,
      title: "Health Insurance",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: life,
      title: "Life Insurance",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: car,
      title: "Auto Insurance",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: business,
      title: "Business Insurance ",
      desc: "Explore Homeowners Insurance",
    },
    {
      icon: annuities,
      title: "Annuities ",
      desc: "Explore Annuities",
    },
  ];

  return (
    <>
      <Navbar
        navClass="defaultscroll sticky"
        logolight={true}
        menuClass="navigation-menu nav-left nav-light"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{ backgroundImage: `url(${bg3})` }}
      >
        <div className="bg-overlay bg-gradient-overlay-2"></div>
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-12">
              <div className="title-heading text-center">
                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">
                  Services
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="about-left">
                <div className="position-relative shadow p-2 rounded-top-pill rounded-5 bg-white img-one">
                  <img
                    src={hero}
                    className="img-fluid rounded-top-pill rounded-5"
                    alt=""
                  />
                  <div className="position-absolute top-0 start-0 z-n1">
                    <img src={dots} className="avatar avatar-xl-large" alt="" />
                  </div>
                </div>

                <div className="img-two shadow rounded-3 overflow-hidden p-2 bg-white">
                  <img src={image1} className="img-fluid rounded-3" alt="" />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4 className="title mb-3">Meeting Your Needs</h4>
                <p className="text-muted para-desc mb-0">
                  Piertop focuses on your most critical insurance needs: Life,
                  Health, Home, Flood Auto, and Business. The world of Insurance
                  can be both difficult to navigate and time consuming; rely on
                  us to steer you every step of the way in protecting what
                  matters to you most.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
            <div className="col">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Protections</h4>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {featureData2.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    navigate(RoutesEnums.SERVICE_DETAIL, {
                      state: data2[index],
                    });
                  }}
                  className="col-md-4"
                  key={index}
                >
                  <div className="position-relative features text-center mx-lg-4 px-md-1">
                    <div className="feature-icon position-relative overflow-hidden d-flex justify-content-center">
                      <FiHexagon className="hexagon" />
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <img
                          src={item.icon}
                          width="25px"
                          height="25px"
                          alt="icon"
                        />
                      </div>
                    </div>

                    <div className="mt-4">
                      <Link to="" className="fw-medium title text-dark fs-5">
                        {item.title}
                      </Link>
                      <p className="text-muted mt-3 mb-0">{item.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
